import VendPackage from './VendPackage'
import PackageConfig from './PackageConfig'
import FullServicePricingType from './FullServicePricingType'
import {SelectItem} from 'primeng/primeng';
export class FullServicePricingLineItem {
    ID?: number;
    RequestID?: number;
    CustomerNumber?: string;
    PackageID?: number;
    PricingTypeID?: number;
    FullServicePricingType?: FullServicePricingType;
    VendRateAmount?: number;
    CommissionRate?: number;
    VendPackage?: VendPackage;
    ApplyToAllCustomers?: boolean;
    PackageConfigID?: number;
    PackageConfig?: PackageConfig;
    CommissionRateSelectItems?: SelectItem[];

}

export default FullServicePricingLineItem;